export default __webpack_public_path__ + "static/media/Discord.a00c4844.svg";